import React from "react";
import { FiBookOpen } from "react-icons/fi";

export default function UserGuide() {
  return (
    <div className="min-h-screen bg-[#F0EFEB] p-6 font-sans flex flex-col items-center justify-center text-center">
      <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center border border-[#0C4550]/30 shadow-md mb-6">
        <FiBookOpen className="text-[#0C4550] w-10 h-10" />
      </div>
      <h1 className="text-4xl font-bold text-[#0C4550]">User Guide</h1>
      <p className="text-xl text-gray-500 mt-4 font-medium tracking-wide italic">
        Coming Soon...
      </p>
      <div className="mt-8 w-16 h-1 bg-[#C5F637] rounded-full"></div>
    </div>
  );
}